import HttpService from "../Services/HttpService";
import LeaderboardEntry from "../Models/LeaderboardEntry";

class LeaderboardRepository
{
  public leaderboardEntries: LeaderboardEntry[] = [];

  public async load(from: Date, to: Date): Promise<LeaderboardEntry[]>
  {
    const url = `/Game/TeamScores?start=${from.toISOString()}&end=${to.toISOString()}`;
    this.leaderboardEntries = await HttpService.get<LeaderboardEntry[]>(url);
    return this.leaderboardEntries;
  }
}

export const leaderboardRepository = new LeaderboardRepository();